import { injectable } from "inversify";
import MasterDataProvider from "../../providers/master_data/master_data_provider";
import MasterDataRepository from "../../repositories/master_data.repository";
import MasterItemEntity from "../../entities/master_item.entity";

interface _props {
    masterDataRepository: MasterDataRepository;
    masterDataProvider: MasterDataProvider;
}

@injectable()
export default class GetCallTypesUseCase {
    private masterDataRepository: MasterDataRepository;
    private masterDataProvider: MasterDataProvider;

    constructor(_:_props){
        this.masterDataProvider = _.masterDataProvider;
        this.masterDataRepository = _.masterDataRepository;
    }

    public call = async ():Promise<MasterItemEntity[]> => {
        if(this.masterDataProvider.Actions.typesCall.length > 0) return this.masterDataProvider.Actions.typesCall;
        const response = await this.masterDataRepository.getCallTypes();
        this.masterDataProvider.Actions.setTypesCall(response);
        return response;
    }
}

export const GetCallTypesUseCaseName = "GetCallTypesUseCase";